import { KeyboardShortcutsOption } from 'owa-shortcut-option';
var configurationSubCategory = {
    key: 'configuration',
    titleStringKey: 'optionSubcategory_configuration',
    options: [KeyboardShortcutsOption],
};
export default configurationSubCategory;
//# sourceMappingURL=configurationSubCategory.js.map